import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { MessageStream } from './MessageStream';
import { InputArea } from './InputArea';
import { flattenMessagePages, useMessages, useSendMessage } from './hooks';

function ProjectChatInner({ projectId, chatId }: { projectId: string; chatId: string }) {
  const query = useMessages(chatId);
  const send = useSendMessage(chatId);
  const messages = flattenMessagePages(query.data);

  return (
    <div style={{ height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden', background: 'var(--surface)' }}>
      <div style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)' }}>
        <div className="section-label" style={{ marginBottom: 2 }}>Project Chat</div>
        <div className="mono muted" style={{ fontSize: 'var(--text-xs)' }}>{projectId} / {chatId}</div>
      </div>
      <MessageStream messages={messages} loading={query.isLoading} />
      <InputArea onSend={(body) => send.mutateAsync(body)} disabled={send.isPending} />
    </div>
  );
}

export function ProjectChatPage({ projectId, chatId }: { projectId: string; chatId: string }) {
  const client = useMemo(() => new QueryClient({ defaultOptions: { queries: { retry: false }, mutations: { retry: false } } }), []);
  return (
    <QueryClientProvider client={client}>
      <ProjectChatInner projectId={projectId} chatId={chatId} />
    </QueryClientProvider>
  );
}
